import { render } from "./SiteHome.vue?vue&type=template&id=198ead61"
import script from "./SiteHome.vue?vue&type=script&lang=js"
export * from "./SiteHome.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__